<script setup lang="ts">
import { onBeforeMount } from 'vue'

import { storeToRefs } from 'pinia'
import { RouterView } from 'vue-router'

import { Toaster } from '@/components/ui/sonner'

import 'vue-sonner/style.css'
import { getExpirationDate } from './helpers/decodeJWT'
import { useUserStore } from './stores/userStore'

const userStore = useUserStore()
const { token } = storeToRefs(userStore)

onBeforeMount(() => {
  if (!token.value) return
  const d = getExpirationDate(token.value)
  const curDate = new Date()
  if (!d || curDate > d) {
    userStore.clearAuth()
  }
})
</script>

<template>
  <Toaster />
  <RouterView />
</template>
